export const getSubdomain = (): string => {
    const hostname = window.location.hostname
    const parts = hostname.split('.')

    if (process.env.NODE_ENV === 'development') {
        return String(process.env.REACT_APP_THEME_VARIANT_NAME)
    }

    return parts.length ? parts[0] : ''
}

export const getLoginLogoSrcForSubdomain = (subdomain: string): string => {
    if (subdomain.includes('outpayce')) {
        return '/images/logos/brand-logo-lg_amadeus_outpayce.png'
    }
    if (subdomain.includes('lastminute')) {
        return '/images/logos/brand-logo-lg_sabre_lastminute_white.png'
    }
    if (subdomain.includes('kraken')) {
        return '/images/logos/brand-logo-lg_kraken.png'
    }
    if (subdomain.includes('monavate')) {
        return '/images/logos/brand-logo-lg_monavate_black.png'
    }
    if (subdomain.includes('amadeus')) {
        return '/images/logos/brand-logo-lg_globex_corp.png'
    }
    if (subdomain.includes('sabre')) {
        return '/images/logos/brand-logo-lg_sabre.png'
    }
    if (subdomain.includes('sofi')) {
        return '/images/logos/brand-logo-lg_sofi.png'
    }
    if (subdomain.includes('choice')) {
        return '/images/logos/brand-logo-lg_shell.png'
    }
    if (subdomain.includes('udms')) {
        return '/images/logos/brand-logo-lg-udms.png'
    }
    if (subdomain.includes('barclays')) {
        return '/images/logos/brand-logo-lg_barclays.png'
    }

    return '/images/logos/brand-logo-lg-login.png'
}

export const getLoginButtonStylingForSubdomain = (
    subdomain: string
): { [key: string]: any } => {
    if (subdomain.includes('outpayce')) {
        return {
            backgroundColor: '#0075c9',
            '&:hover': {
                backgroundColor: '#0065B7',
            },
        }
    }
    if (subdomain.includes('lastminute')) {
        return {}
    }
    if (subdomain.includes('kraken')) {
        return {
            backgroundColor: '#FF3B29',
            '&:hover': {
                backgroundColor: '#de2224',
            },
        }
    }
    if (subdomain.includes('monavate')) {
        return {
            backgroundColor: '#202133',
            color: '#fff',
            '&:hover': {
                backgroundColor: '#161723',
            },
        }
    }
    if (subdomain.includes('amadeus')) {
        return {}
    }
    if (subdomain.includes('sabre')) {
        return {
            backgroundColor: '#E2553C',
            '&:hover': {
                backgroundColor: '#9E3B2A',
            },
        }
    }
    if (subdomain.includes('sofi')) {
        return {
            backgroundColor: '#09A7D1',
            '&:hover': {
                backgroundColor: '#09A7D1',
            },
        }
    }
    if (subdomain.includes('choice')) {
        return {
            backgroundColor: '#FFC72C',
            '&:hover': {
                backgroundColor: '#B28B1E',
            },
        }
    }
    if (subdomain.includes('udms')) {
        return {
            backgroundColor: '#215DB0',
            '&:hover': {
                backgroundColor: '#17417B',
            },
        }
    }
    if (subdomain.includes('barclays')) {
        return {
            backgroundColor: '#00aeef',
            '&:hover': {
                backgroundColor: '#0079a7',
            },
        }
    }

    return {}
}

export const getThemeVariantForSubdomain = (subdomain: string): number => {
    if (subdomain.includes('outpayce')) {
        return 2
    }
    if (subdomain.includes('lastminute')) {
        return 3
    }
    if (subdomain.includes('kraken')) {
        return 4
    }
    if (subdomain.includes('monavate')) {
        return 5
    }
    if (subdomain.includes('amadeus')) {
        return 6
    }
    if (subdomain.includes('sabre')) {
        return 7
    }
    if (subdomain.includes('sofi')) {
        return 11
    }
    if (subdomain.includes('choice')) {
        return 13
    }
    if (subdomain.includes('barclays')) {
        return 14
    }
    if (subdomain.includes('udms')) {
        return 1
    }

    return 1
}
